'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = runEditor;
function runEditor(window, packagesStructure, requirejs, editorModel, queryUtil, config) {
  var packagesArr = ['santa-editor-symbols', 'rEditor', 'compPanelInfra', 'core', 'tpa', 'util', 'zepto', 'react', 'reactDOM', 'lodash', 'superAppMenuInfra', 'savePublish', 'panels', 'experiment', 'staticAssets', 'textControls', 'mediaFrame', 'keyboardMaster', 'baseUI', 'uiAnimations', 'panelUtils', 'mediaServices', 'color', 'pms', 'databaseEditor', 'json', 'gfppData', 'backgroundPresets', 'styles', 'pagesMenu', 'popups'];

  if (queryUtil.isParameterTrue('isqa')) {
    packagesArr.push('qaAutomation', 'debugTools');
  }
  if (queryUtil.isParameterTrue('isTpaIntegration')) {
    packagesArr.push('tpaIntegrationEditor', 'jasmine', 'jasmine-html');
  }
  if (queryUtil.isParameterTrue('isUiLibIntegration')) {
    packagesArr.push('uiLibIntegrationEditor', 'jasmine', 'jasmine-html');
  }
  if (queryUtil.isParameterTrue('isPlatformIntegration')) {
    packagesArr.push('platform', 'platformIntegrationEditor', 'jasmine', 'jasmine-html');
  }

  var onError = errorHandler;

  var prefetch = window.isPrefetchMode || window.location.pathname.indexOf('prefetch') > 0 || queryUtil.isParameterTrue('prefetch');

  var languagePackageName = void 0;
  if (prefetch) {
    packagesArr.push('addPanelData', 'addPanelInfra', 'addPanel', 'addPanelDataConsts', 'addPanelSectionsEN');

    var languageCode = window.editorModel && window.editorModel.languageCode;
    languagePackageName = languageCode && 'addPanelSections' + languageCode.toUpperCase();
    var existsInPackagesStructure = packagesStructure.indexOf(languagePackageName) !== -1;
    var existsInPackagesArr = packagesArr.indexOf(languagePackageName) !== -1;
    var isSupportedAddPanelLanguage = !!config.paths[languagePackageName];
    if (!existsInPackagesStructure && !existsInPackagesArr && isSupportedAddPanelLanguage) {
      packagesArr.push(languagePackageName);
    }

    // Preload scripts for caching
    if (window.define) {
      onError = function onError() {};
      var plugins = {
        json: true,
        text: true,
        experiment: true
      };
      var dummy = function dummy() {
        return {};
      };
      var define = window.define;
      window.define = function (name) {
        var args = Array.apply(null, arguments);
        if (!plugins.hasOwnProperty(name) && name !== 'zepto') {
          for (var i = 1; i < args.length; ++i) {
            if (typeof args[i] === 'function') {
              args[i] = dummy;
            }
          }
        }
        return define.apply(this, args);
      };
      window.define.amd = define.amd;
    }
  }

  if (window.define) {
    window.define('bluebird', [], function () {
      return Promise;
    });
  }

  function loaded() {
    if (prefetch) {
      return;
    }

    function buildFunctionParametersObject(_pkgs, args) {
      return _pkgs.reduce(function (result, pkg, index) {
        result[pkg.replace(/^.*:/, '')] = args[index];
        return result;
      }, {});
    }
    var p = buildFunctionParametersObject(packagesArr, arguments);

    if (languagePackageName) {
      p.addPanel.sections.applyTranslatedSections(p[languagePackageName]);
    }

    p.rEditor.editorMain.start(p);
  }

  if (queryUtil.getParameterByName('debug')) {
    requirejs(packagesArr, loaded);
  } else {
    requirejs(packagesArr, loaded, onError);
  }

  function errorHandler(err) {
    if (!config.urlArgs) {
      if (err.requireModules) {
        err.requireModules.forEach(function (module) {
          requirejs.undef(module);
        });
      }
      config.urlArgs = 'c=' + Date.now();
      requirejs.config(config);
      requirejs(packagesArr, function () {
        err.errn = 'REQUIREJS_RETRY_ERROR';
        err.errc = 111025;
        err.severity = 10;
        requirejs.onError(err);
      }, function (error) {
        requirejs.onError(error);
      });
    }
  }
}
//# sourceMappingURL=runEditor.js.map